import { render, staticRenderFns } from "./ConfirmationPanel.vue?vue&type=template&id=a203a476"
import script from "./ConfirmationPanel.vue?vue&type=script&lang=ts"
export * from "./ConfirmationPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports